import React from 'react';
import { LegalPage, H2, H3, P, UL, Callout } from '../components/LegalPage';

const LeitpalelDeleteAccount = () => {
  return (
    <LegalPage
      testid="leitpalel-delete-account"
      eyebrow="Leitpalel for Dummies"
      title="Eliminar cuenta y datos"
      subtitle="App de Inversiones Tair SpA (tair.site)"
      lastUpdated="Última actualización: Julio 2026"
      backTo="/leitpalel"
      backLabel="Volver · Leitpalel"
    >
      {/* ============ ESPAÑOL ============ */}
      <H2>Español</H2>
      <H3>Cómo eliminar tu cuenta desde la app (recomendado)</H3>
      <UL items={[
        <>Abre la app <strong className="text-white">Leitpalel</strong> e inicia sesión.</>,
        <>Toca el ícono de <strong className="text-white">persona</strong> (menú de cuenta) en la pantalla principal, o entra a <strong className="text-white">Acerca de → Mi cuenta</strong>.</>,
        <>Toca <strong className="text-white">"Eliminar cuenta"</strong> y confirma.</>,
      ]} />

      <Callout
        title="Qué se elimina"
        items={[
          'Tu cuenta, email y nombre',
          'Historial de práctica y registros de suscripción',
          'Eliminación inmediata y permanente de nuestros servidores',
          'No conservamos copias ni períodos de retención adicionales',
          'Las grabaciones de voz del Modo Sinagoga nunca se almacenan (se procesan y descartan al instante)',
        ]}
      />

      <P>
        <strong className="text-white">Alternativa por email:</strong> escribe a{' '}
        <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>{' '}
        desde el email de tu cuenta con el asunto "Eliminar mi cuenta" y la eliminaremos en un plazo máximo de 7 días.
      </P>
      <P>
        <em className="text-white/50">Nota: la suscripción Premium se administra en App Store / Google Play y debes cancelarla desde tu tienda si está activa.</em>
      </P>

      {/* ============ ENGLISH ============ */}
      <H2>English</H2>
      <H3>How to delete your account from the app (recommended)</H3>
      <UL items={[
        <>Open the <strong className="text-white">Leitpalel</strong> app and sign in.</>,
        <>Tap the <strong className="text-white">person icon</strong> (account menu) on the main screen, or go to <strong className="text-white">About → My account</strong>.</>,
        <>Tap <strong className="text-white">"Delete account"</strong> and confirm.</>,
      ]} />

      <Callout
        title="What is deleted"
        items={[
          'Your account, email and name',
          'Practice history and subscription records',
          'Deleted immediately and permanently from our servers',
          'We keep no copies and apply no additional retention period',
          'Synagogue Mode voice recordings are never stored (processed ephemerally and discarded)',
        ]}
      />

      <P>
        <strong className="text-white">Email alternative:</strong> write to{' '}
        <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>{' '}
        from your account email with the subject "Delete my account" and we will delete it within 7 days.
      </P>
      <P>
        <em className="text-white/50">Note: Premium subscriptions are managed by App Store / Google Play and must be cancelled in your store if active.</em>
      </P>

      {/* ============ FRANÇAIS ============ */}
      <H2>Français</H2>
      <P>
        Ouvrez l'app <strong className="text-white">Leitpalel</strong> → icône{' '}
        <strong className="text-white">personne</strong> (ou À propos → Mon compte) →{' '}
        <strong className="text-white">« Supprimer le compte »</strong>. Votre compte, email, nom et historique
        sont supprimés immédiatement et définitivement. Alternative : écrivez à{' '}
        <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>{' '}
        (suppression sous 7 jours).
      </P>

      {/* ============ PORTUGUÊS ============ */}
      <H2>Português</H2>
      <P>
        Abra o app <strong className="text-white">Leitpalel</strong> → ícone de{' '}
        <strong className="text-white">pessoa</strong> (ou Sobre → Minha conta) →{' '}
        <strong className="text-white">"Excluir conta"</strong>. Sua conta, email, nome e histórico são
        excluídos imediata e permanentemente. Alternativa: escreva para{' '}
        <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>{' '}
        (exclusão em até 7 dias).
      </P>
    </LegalPage>
  );
};

export default LeitpalelDeleteAccount;
